module.exports = __webpack_public_path__ + "img/device-settings.8bfff217.png";